(function($){

  $( document ).ready(function() {
      scrollFx.init({debug: false});
//      preloadImages.init({debug: false});
  
    if ($(window).scrollTop() > 100){
        $('#header').addClass('is-scrolled');
    } else{
        $('#header').removeClass('is-scrolled');

    }
    $("#wraplogo").click(function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#nav").offset().top
        }, 1000);

    });


      $('.hamburger').click(function(){
          $(this).toggleClass('is-active');
          $('.navbar-wrapper').toggleClass('is-active');
          $('#cookie-box').toggleClass('active');
          $('#logo').toggleClass('active');
          $('#logotiny').toggleClass('active');
          $('.navbar').toggleClass('active');
      });


        $(window).scroll(function(){
            if ($(window).scrollTop() > 100){
                $('#header').addClass('is-scrolled');
            } else{
                $('#header').removeClass('is-scrolled');

            }
        });


      $("#wrap-arrow").click(function() {
          $([document.documentElement, document.body]).animate({
              scrollTop: $("#home").offset().top
          }, 1000);
  
      });
  
      $('#nav>li>a').click(function() {
        // $('#nav>li>a').removeClass('active');
        // $(this).addClass('active');
          $('.hamburger,.navbar-wrapper').removeClass('is-active');
          $('.navbar').removeClass('active');
        var nb = $(this).attr('data-attr');
        console.log("#"+nb)
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#"+nb).offset().top
        }, 1000);
      
      });
  
  
      $(window).scroll(function (event) {
          var scroll = $(window).scrollTop();
          if(scroll>=500){
              $('#wrap-arrow').addClass('active');
          } else{
              $('#wrap-arrow').removeClass('active');
  
          }
      });
  });
  
      $('#carousel-splash').slick({
          autoplay: true,
          autoplaySpeed: 5000,
          pauseOnHover: true, 
          prevArrow:'<svg version="1.1" id="previous" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16.2 30.2" style="" xml:space="preserve" class="slick-arrow"><polyline class="previous" points="15.6,29.7 1.1,15.1 15.6,0.5 "></polyline></svg>',
          nextArrow:'<svg version="1.1" id="next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16.2 30.2" style="" xml:space="preserve" class="slick-arrow"><polyline id="XMLID_53_" class="next" points="0.5,0.5 15.1,15.1 0.5,29.7 "></polyline></svg>',
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          adaptiveHeight: true,
          mobileFirst: true,
          responsive: [
              {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: true,
                    dots: true,
                  }
              },
              {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: true,
                    dots: true,                    }
              },
          ]
          
/*
          appendDots: $('#carousel-dots'),
          arrows: true,
          prevArrow: true,
          nextArrow: true,
          dots: true,
          infinite: true,
          speed: 500,
          fade: false,
          cssEase: 'cubic-bezier(0.19,1,.22,1)',
          adaptiveHeight: false,
          mobileFirst: true,
          responsive: [
              {
                  breakpoint: 768,
                  settings: {
                      dots: true,
                  }
              },
              {
                  breakpoint: 992,
                  settings: {
                      dots: true,
                      arrows: true,
                  }
              },
              {
                  breakpoint: 1200,
                  settings: {
                      dots: true,
                      arrows: true,
                  }
              },
          ]*/
      });
  
  
      $('#carousel-splash-know').slick({
        autoplay: true,
        autoplaySpeed: 6000,
        pauseOnHover: false,
        prevArrow:'<svg version="1.1" id="previous" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16.2 30.2" style="" xml:space="preserve" class="slick-arrow"><polyline class="previous" points="15.6,29.7 1.1,15.1 15.6,0.5 "></polyline></svg>',
        nextArrow:'<svg version="1.1" id="next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16.2 30.2" style="" xml:space="preserve" class="slick-arrow"><polyline id="XMLID_53_" class="next" points="0.5,0.5 15.1,15.1 0.5,29.7 "></polyline></svg>',
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        adaptiveHeight: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                }
            },
        ]
    });


  
  })(jQuery);